@if (filterForm != null) {
    <div class="greenhousing-energy-icon">
    <div class="icon-default"></div>
    <div class="icon-hover" (click)="showGreenEnergy($event)"></div>
    <div class="greenhousing-tooltip">
        <ev-tooltip-img
            [imgUrl]="greenEnergyTooltipImgUrl"
            [visible]="showGreenHousingTooltip"
            [left]="-1"
            [top]="-300"
            [arrow]="'bottom'"
            [arrowBottomAlign]="16"
            (close)="hideGreenEnergy()"
        >
            Boligen oppfyller et av kriteriene for Grønn bolig.
            <br />
            <a href="{{ greenHomeArticleUrl }}" target="_blank">
                Les mer om hvordan Eiendomsverdi klassifiserer grønne boliger her.<span class="external-link"></span
            ></a>
        </ev-tooltip-img>
    </div>
</div>
    <h2 class="expand-header" [class.expanded]="this.filterForm().expanded().value()" (click)="toggleExpanded()">Grønn bolig</h2>

    <div class="expander greenhousing" [class.expanded]="this.filterForm().expanded().value()">
        <div class="container">
            <ul>
                <li class="toggle">
                    <ev-toggle
                        [active]="this.filterForm().isGreenHome().value()"
                        [style]="EVToggleStyle.BRIGHT"
                        [size]="16"
                        (change)="toggleIsGreenHome(this.filterForm().isGreenHome().value())"
                    ></ev-toggle>
                    <span class="label">Grønn bolig</span>
                </li>
                @for (greenHome of this.filterForm().greenHomeBasisTypes; track $index) {
                    <li class="check-box" [class.disabled]="!this.filterForm().isGreenHome().value()" (click)="toggleSelectedGreenHome(greenHome().value())">                        
                        <input type="checkbox" class="checkbox-icon" [formField]="greenHome.selected" [class.selected]="greenHome.selected().value()" />
                        <label>{{ greenHome.description().value() }} </label>
                    </li>
                }
            </ul>
        </div>
    </div>
}
